import { Module } from 'vuex';
import { getters } from './getters';
import { mutations } from './mutations';
import { RootState } from '@/store/types';
import { ISortState } from '@/store/interfaces';

export const state: ISortState = {
  table: {},
};

const namespaced = true;

export const sortState: Module<ISortState, RootState> = {
  namespaced,
  state,
  getters,
  mutations,
};
